export const ALLOWED_PRE_TYPES = ['0', '1']

export function filterAuditionLotteryOptions (options) {
    return (options || []).filter(o => ALLOWED_PRE_TYPES.includes(o.dictValue))
}

export function hxwyszHomeLocation (preType) {
    const query = {}
    if (preType != null && preType !== '' && ALLOWED_PRE_TYPES.includes(String(preType))) {
        query.preType = String(preType)
    }
    return { path: '/hxwysz', query }
}

export function isPeriodOperable (period) {
    if (!period) return false
    if (period.status !== 1) return false
    if (period.remainSeconds != null && period.remainSeconds <= 0) return false
    return true
}
